module.exports = __webpack_public_path__ + "assets/img/crayon13.c4e9b09f.png";